export default __webpack_public_path__ + "static/media/041-toilet paper.19477109.svg";